<template>
  <div
    style="text-align: right;"
  >
    <!--<el-tooltip-->
      <!--class="item"-->
      <!--effect="dark"-->
      <!--content="Módosítás"-->
      <!--placement="top"-->
      <!--v-can="'process.task.update'"-->
    <!--&gt;-->
      <!--<el-button-->
        <!--size="mini"-->
        <!--icon="el-icon-edit"-->
        <!--@click="updateTask"-->
      <!--/>-->
    <!--</el-tooltip>-->
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'process.task.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteTask"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['task'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteTask() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('task/delete', this.task.id);
          this.$store.dispatch('task/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateTask() {
        this.$router.push('/representative-processes/tasks/update/' + this.task.id);
      }
    }
  };
</script>
